import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './WorkProjectModal.css';

const WorkProjectModal = ({ isOpen, onClose }) => {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    if (!isOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const modal = (
    <div className="work-modal-overlay" onClick={onClose}>
      <div className="work-modal-content" onClick={e => e.stopPropagation()}>
        <div className="work-modal-header">
          <span className="work-modal-badge">Current Role Project</span>
          <h3>The Project Hub</h3>
          <p>
            A private internal application I am building at work. The live
            system is not public, so this preview highlights the project
            interface without exposing company access.
          </p>
        </div>

        <div className="work-modal-image-frame">
          {imageFailed ? (
            <div className="work-modal-image-fallback">
              Project preview image unavailable. Add it at public/Projectimg/TPHworkimg.png.
            </div>
          ) : (
            <img
              src={`${process.env.PUBLIC_URL}/Projectimg/TPHworkimg.png`}
              alt="The Project Hub internal application preview"
              onError={() => setImageFailed(true)}
            />
          )}
        </div>

        <button className="work-modal-close" onClick={onClose}>Close</button>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
};

export default WorkProjectModal;
